import * as Yup from "yup";

export const internalChatValidationSchema = Yup.object({
    /** Campos básicos **/
    title: Yup.string()
        .required("El título es obligatorio")
        .min(5, "Debe tener al menos 5 caracteres"),

    richValue: Yup.string()
        .required("El contenido es obligatorio")
        .min(10, "Debe tener al menos 10 caracteres"),

    /** Remitente y asignatario **/
    from: Yup.object({
        id: Yup.mixed().required(),
        name: Yup.string().required(),
    })
        .nullable()
        .required("Debes seleccionar un remitente"),

    assign_to: Yup.object({
        id: Yup.mixed().required(),
        name: Yup.string().required(),
    })
        .nullable()
        .required("Debes asignar a alguien"),

    /** Selects simples **/
    type_reaction: Yup.object().nullable().required("Selecciona un tipo de reacción"),
    set: Yup.object().nullable().required("Selecciona un set"),

    /** Datos opcionales — permiten null/undefined, nunca null al enviar **/
    gender: Yup.mixed().nullable().notRequired(),
    training_plan: Yup.mixed().nullable().notRequired(),
    nutrition_plan: Yup.mixed().nullable().notRequired(),
    send_option: Yup.mixed().nullable().notRequired(),

    trigger_type: Yup.object({ id: Yup.mixed().required() }).nullable().notRequired(),
    event_type: Yup.object({ id: Yup.mixed().required() }).nullable().notRequired(),

    /** Arrays: devuelven [] si vienen vacíos **/
    groups: Yup.array()
        .of(Yup.object({ id: Yup.number().required() }))
        .default([]),

    specialists: Yup.array()
        .of(Yup.object({ id: Yup.number().required() }))
        .default([]),

    categories: Yup.array()
        .of(Yup.object({ id: Yup.number().required() }))
        .default([]),

    /** Más selects **/
    sending: Yup.object().nullable().notRequired(),
    days: Yup.object().nullable().notRequired(),
    frequency: Yup.object().nullable().notRequired(),

    /** Arrays simples **/
    selected_days: Yup.array()
        .of(Yup.string())
        .default([]),

    /** Fechas y edad **/
    date_start: Yup.date().nullable().notRequired(),
    date_end: Yup.date().nullable().notRequired(),

    hour: Yup.string()
        .nullable()
        .transform(v => (v === null ? undefined : v))
        .notRequired(),

    min_age: Yup.number()
        .nullable()
        .transform(v => (v === null ? undefined : v))
        .notRequired(),
    max_age: Yup.number()
        .nullable()
        .moreThan(Yup.ref("min_age"), "Debe ser mayor que la edad mínima")
        .notRequired(),
});
